import { fetchJSONWithTimeout } from '@noths/polaris-client-utils';

import { logger } from 'src/utils/serverLogger';
import type { ContentstackListingsControlsConfig } from './types/ContentstackListingsControlsConfig';

const listingsControlsConfigUrl =
  'https://assets.contentstack.io/v3/assets/blt63f2f7afd19b09c2/blt1954bee97926b09b/sort-and-facet-configurations.json';

const CACHE_DURATION_MS = 12 * 60 * 60 * 1000; // 12 hours
const CLIENT_TIMEOUT_MS = 750;

let cachedConfig: ContentstackListingsControlsConfig | null = null;
let cacheTimestamp: number | null = null;

const isCacheValid = () => {
  if (cachedConfig === null || cacheTimestamp === null) {
    return false;
  }
  return Date.now() - cacheTimestamp < CACHE_DURATION_MS;
};

export const fetchListingsControlsConfig = async () => {
  if (isCacheValid()) {
    return cachedConfig;
  }

  try {
    const response = await fetchJSONWithTimeout(listingsControlsConfigUrl, {
      timeout: CLIENT_TIMEOUT_MS,
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch listings controls config: ${response.statusText}`);
    }

    cachedConfig = await response.json();
    cacheTimestamp = Date.now();
    return cachedConfig;
  } catch (error) {
    logger.error(
      `Error fetching listings controls config: ${
        error instanceof Error ? error.message : String(error)
      }`,
    );
    return null;
  }
};

export const resetListingsControlsConfigCache = () => {
  cachedConfig = null;
  cacheTimestamp = null;
};
